import React from "react";

const FlashMessage = ({ message, onClose }) => {
  return (
    <div className="rounded-md bg-blue-200 p-4 border border-blue-500">
      <div className="flex items-center">
        <div className="flex-shrink-0 cursor-pointer" onClick={onClose}>
          <svg
            className="h-5 w-5 text-blue-400"
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            <path
              fillRule="evenodd"
              d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
              clipRule="evenodd"
            />
          </svg>
        </div>
        <div className="ml-3">
          <div className="mt-2 text-sm leading-5 text-blue-700">{message}</div>
        </div>
      </div>
    </div>
  );
};

export default FlashMessage;
